import React from "react"
import WithBlock from "data/wrappers/WithBlock"
import Editor from "features/editor"

export default class BlockEditor extends React.Component {
    render() {
        return (
            <WithBlock blockId={this.props.params.blockId}>
                {({ block, onChange }) => <Editor isCustomBlock onChange={onChange} page={block} />}
            </WithBlock>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/BlockEditor.js